import { useRef, useState, useMemo } from 'react'
import { useSpring, animated, config } from 'react-spring'

const letterColors = [
  '#70d6ff',
  '#ff70a6',
  '#ff9770',
  '#ffd670',
  '#e9ff70',
  '#ffbe0b',
  '#fb5607',
  '#ff006e',
  '#8338ec',
  '#3a86ff',
  '#004e64',
  '#00a5cf',
  '#9fffcb',
  '#25a18e',
  '#7ae582'
]

export const LoginScreen = ({ onSuccess }) => {
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [showError, setShowError] = useState(false)
  const [attemptCount, setAttemptCount] = useState(0)
  const timeoutRef = useRef(null)

  // Spring for error popup (wobbly)
  const errorSpring = useSpring({
    opacity: showError ? 1 : 0,
    y: showError ? 0 : -100,
    config: config.wobbly
  })

  // Replace react-spring with simple CSS transitions
  const errorStyle = {
    position: 'absolute', // was fixed
    top: '25%',
    left: '2rem',
    // transform & opacity animated via spring
    // transition removed in favor of spring
    background:
      'linear-gradient(135deg, rgba(255,107,107,0.9) 0%, rgba(255,107,107,0.7) 50%, rgba(255,107,107,0.5) 100%)',
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    borderRadius: '20px',
    padding: '20px 30px',
    color: 'white',
    fontSize: '18px',
    fontWeight: '500',
    textAlign: 'center',
    boxShadow: '0px 0px 30px rgba(255,107,107,0.3)',
    border: '1px solid rgba(255,255,255,0.2)',
    fontFamily: "'Poppins', 'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
    zIndex: 1000,
    width: 'calc(100% - 4rem)', // was 100%
    boxSizing: 'border-box' // added to include padding in width
  }

  const errorMessages = [
    'Leider noooot',
    'Was los diggah?',
    'Du Pappnase!',
    'Hehehe',
    'Willste wissen, was das Passwort ist?',
    'Das kostet paar Drinks',
    'In Amstiiii',
    'Hätte auch mal wieder Lust auf ne pappnasige Mephesesh mit dir...',
    'Na ok: check deinen Kugeschreiber Brudi'
  ]

  const handleSubmit = (e) => {
    e.preventDefault()
    if (password === 'LPN') {
      onSuccess()
    } else {
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
      const currentMessage = errorMessages[attemptCount % errorMessages.length]
      setError(currentMessage)
      setPassword('')
      setShowError(true)
      setAttemptCount((prev) => prev + 1)
      timeoutRef.current = setTimeout(() => {
        setShowError(false)
        setTimeout(() => setError(''), 300)
      }, 3000)
    }
  }

  // Build colored marquee content (letters cycle through letterColors)
  const ribbonText = 'Happy Birthday du Pappnase!  '
  const repeatsPerHalf = 6
  const { seq1, seq2 } = useMemo(() => {
    const build = (startIndex, reps) => {
      const out = []
      let idx = startIndex
      for (let r = 0; r < reps; r++) {
        for (let i = 0; i < ribbonText.length; i++) {
          const ch = ribbonText[i]
          const color = letterColors[idx % letterColors.length]
          out.push(
            <span key={`s${startIndex}-${r}-${i}`} style={{ color, marginRight: ch === ' ' ? '1rem' : '0' }}>
              {ch}
            </span>
          )
          idx++
        }
      }
      return out
    }
    const first = build(0, repeatsPerHalf)
    const offset = (ribbonText.length * repeatsPerHalf) % letterColors.length
    const second = build(offset, repeatsPerHalf)
    return { seq1: first, seq2: second }
  }, [])

  return (
    <div
      className="fade-in"
      style={{
        width: '100%',
        height: '100%',
        backgroundColor: '#0F2027',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute', // was fixed
        top: 0,
        left: 0
      }}>
      <form
        onSubmit={handleSubmit}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          maxWidth: '400px',
          padding: '2rem'
        }}>
        {/* Ribbon + Controls wrapper */}
        <div
          style={{
            position: 'relative',
            width: '100%',
            marginBottom: '0.5rem',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}>
          {/* Diagonal ribbon behind controls */}
          <div
            aria-hidden="true"
            className="login-ribbon"
            style={{
              position: 'absolute',
              left: '-60%',
              top: '50%',
              transform: 'translateY(-50%) rotate(45deg)',
              width: '220%',
              padding: '40px 0',
              // background: 'linear-gradient(135deg, rgba(46, 196, 182, 0.2) 0%, rgba(46, 196, 182, 0.1) 100%)',
              // border: '1px solid rgba(46, 196, 182, 0.4)',
              // backdropFilter: 'blur(12px)',
              // WebkitBackdropFilter: 'blur(12px)',
              borderRadius: '16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              pointerEvents: 'none',
              zIndex: 0
            }}>
            <div className="login-ribbon-track" style={{ padding: '0 2rem' }}>
              <span className="login-ribbon-item" style={{ display: 'inline-flex', gap: '0.6rem' }}>
                {seq1}
              </span>
              <span className="login-ribbon-item" style={{ display: 'inline-flex', gap: '0.6rem' }}>
                {seq2}
              </span>
            </div>
          </div>

          {/* Input above ribbon */}
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Gib Passwort diggah!"
            style={{
              position: 'relative',
              zIndex: 1,
              backgroundColor: 'rgba(255,255,255,0.10)',
              backdropFilter: 'blur(12px)',
              WebkitBackdropFilter: 'blur(12px)',
              borderRadius: '16px',
              padding: '14px 18px',
              border: '1px solid rgba(255,255,255,0.2)',
              fontSize: '18px',
              color: 'white',
              caretColor: '#ffffff',
              width: '100%',
              marginBottom: '1.25rem',
              outline: 'none',
              fontFamily: "'Poppins', 'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
              boxShadow: '0 10px 30px rgba(0,0,0,0.28), inset 0 1px 0 rgba(255,255,255,0.08)',
              transition: 'background-color 150ms ease, border-color 150ms ease, box-shadow 150ms ease'
            }}
          />

          {/* Button above ribbon */}
          <button
            type="submit"
            style={{
              position: 'relative',
              zIndex: 1,
              backgroundColor: 'rgba(255,255,255,0.14)',
              backdropFilter: 'blur(12px)',
              WebkitBackdropFilter: 'blur(12px)',
              borderRadius: '16px',
              padding: '14px 28px',
              border: '1px solid rgba(255,255,255,0.25)',
              fontSize: '18px',
              color: 'white',
              fontWeight: '500',
              cursor: 'pointer',
              transition:
                'transform 120ms ease, box-shadow 120ms ease, background-color 150ms ease, border-color 150ms ease',
              fontFamily: "'Poppins', 'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
              boxShadow: '0 12px 36px rgba(0,0,0,0.32), inset 0 1px 0 rgba(255,255,255,0.08)'
            }}>
            Abfahrt 🚀
          </button>
        </div>
      </form>

      {error && (
        <animated.div
          style={{
            ...errorStyle,
            opacity: errorSpring.opacity,
            transform: errorSpring.y.to((y) => `translate(0%, -50%) translateY(${y}px)`) // wobble on Y
          }}>
          {error}
        </animated.div>
      )}
    </div>
  )
}
